import React from 'react';

const MyDeck = () => (
  <div></div>
)

export default MyDeck;